/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Every_Panda_AffirmInputs */

const fr_dry_every_panda_affirm = /** @type {(inputs: Dry_Every_Panda_AffirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

/**

* @param {Dry_Every_Panda_AffirmInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dry_every_panda_affirm = /** @type {((inputs?: Dry_Every_Panda_AffirmInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Every_Panda_AffirmInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dry_every_panda_affirm(inputs)
});